export default __webpack_public_path__ + "static/media/hello-dark.04bc8959.png";